import React from 'react';

import StaticPageLayout from './StaticPageLayout';

const Partnerships = () => (
  <StaticPageLayout
    eyebrow='Grow with us'
    title='Partnerships'
    intro='Evento partners with venues, brands and organisations that share our mission of making events effortless. Let us build something great together.'
    sections={[
      {
        heading: 'Ways to partner',
        bullets: [
          'Venue partners — feature trusted professionals to clients booking your space',
          'Corporate partnerships — offer curated event services to your employees or members',
          'Affiliate & referral — earn by introducing clients and professionals to Evento',
          'Technology partners — integrate with Evento to extend what our platform can do',
        ],
      },
      {
        heading: 'Why partner with Evento',
        bullets: [
          'Access to a growing network of vetted event professionals across Sri Lanka',
          'A modern, trusted brand your customers will recognise',
          'Flexible arrangements tailored to your goals',
          'A dedicated point of contact to make the partnership succeed',
        ],
      },
      {
        heading: 'Get in touch',
        paragraphs: [
          'Tell us a little about your organisation and what you have in mind. Email partnerships@evento.lk and our team will reach out to explore how we can work together.',
        ],
      },
    ]}
  />
);

export default Partnerships;
